<template>
  <div class="listPage">
    <b-row class="mt-2 justify-content-start">
      <!-- Left section filtre -->
      <b-col cols="4" lg="2" xl="1">
        <b-button class="btnFilter mb-5"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="1">
        <b-button class="btnFilter mb-5"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="justify-content-start" v-if="displayFilter">
      <!-- Filtre type d'action -->
      <!--                  <div class="filter-item mb-5">-->
      <!--                    <span class="filter-item-title">{{ $t('filter.action_type') }}</span>-->
      <!--                    <span class="filter-item-content d-flex">-->
      <!--                <select ref="selectTypeAction"-->
      <!--                        v-model="type"-->
      <!--                        class="cursor fs-14px h-auto z-2">-->
      <!--                  <option value="">{{ $t('filter.action_type_choose') }}</option>-->
      <!--                  <option value="CREATE">{{ $t('history.CREATE') }}</option>-->
      <!--                  <option value="DELETE">{{ $t('history.DELETE') }}</option>-->
      <!--                  <option value="MODIFY">{{ $t('history.MODIFY') }}</option>-->
      <!--                  <option value="SEND">{{ $t('history.SEND') }}</option>-->
      <!--                  <option value="CANCEL">{{ $t('history.CANCEL') }}</option>-->
      <!--                  <option value="ACCEPT">{{ $t('history.ACCEPT') }}</option>-->
      <!--                  <option value="REFUSE">{{ $t('history.REFUSE') }}</option>-->
      <!--                  <option value="MODIFY_AND_ACCEPT">{{ $t('history.MODIFY_AND_ACCEPT') }}</option>-->
      <!--                  <option value="ACCEPT_AND_PAY">{{ $t('history.ACCEPT_AND_PAY') }}</option>-->
      <!--                  <option value="PAY">{{ $t('history.PAY') }}</option>-->
      <!--                  <option value="SAVE">{{ $t('history.SAVE') }}</option>-->
      <!--                  <option value="UPLOAD">{{ $t('history.UPLOAD') }}</option>-->
      <!--                  <option value="UPLOAD_API">{{ $t('history.UPLOAD_API') }}</option>-->
      <!--                </select>-->
      <!--                <i class="fa-light fa-chevron_down cursor ml&#45;&#45;20px z-1" size="17px" id="status-chevron">-->
      <!--                </i>-->
      <!--              </span>-->
      <!--                  </div>-->

      <!--Filtre Reference -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="orphan-reference">{{ $t('orphan.reference') }}</label>
        <span class="filter-item-content">
          <input v-model="Reference" id="orphan-reference"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': Reference}"
            :placeholder="$t('orphan.reference')">
        </span>
      </b-col>

      <!--Filtre Name -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="orphan-name">{{ $t('orphan.name') }}</label>
        <span class="filter-item-content">
          <input v-model="Name" id="orphan-name"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
            :placeholder="$t('orphan.name')">
        </span>
      </b-col>

      <!-- Filtre Message Type -->
      <div class="filter-item col-4 mb-5 text-truncate">
        <span class="filter-item-title text-ellipsis" :title="$t('orphan.matching_result_label')">
          {{ $t('orphan.matching_result_label') }}
        </span>
        <a :id="'msgType-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
          href="#">
          <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
          <span :class="'fixed-span-size ' + (messageTypeDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ messageTypeDisplay.label }}</span>
          <i class="fa-light fa-chevron-down" size="17px" id="msgType-chevron"></i>
        </a>
        <b-popover :target="'msgType-picker-link' + '-' + filterType + '-' + randomString"
          :title="$t('orphan.selected_matching_result_none')"
          triggers="focus" placement="bottom">
          <span v-for="(type, index) in resultTypeList" :key="$t('orphan.matching_result.' + type.id) + '-' + index">
            <b-form-checkbox v-model="type.state"
              :value="1"
              :unchecked-value="0">
              <span>{{ $t('orphan.matching_result.' + type.id) }}</span>
            </b-form-checkbox>
          </span>
        </b-popover>
      </div>


      <!-- Filtre date de début -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
          :inputLabel="$t('common.date_start_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBegin">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
          :inputLabel="$t('common.date_end_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEnd">
        </datetime-picker-custom>
      </b-col>

      <!-- Bouton Effacer et Appliquer -->
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3 pr-0">
        <b-button size="sm"
          @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
          @click="clearFilterFields"
          :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end" v-if="items.length > 0">
      <b-button class="btnFilter_2 mx-3"
        @click="extractCSV()">
        <i class="fa-light fa-upload fs-14px"></i>
        <span class="fab-label">{{ $t('common.extract_list') }}</span>
      </b-button>
    </div>

    <spinner v-if="activateSpinner" class="mt-3"></spinner>
    <div v-else>
      <b-table hover
        class="table table-striped"
        v-if="items.length"
        :items="items"
        :fields="fields"
        :selectable="items.length > 0"
        @row-selected="seeOrphansDetails">
        <template #cell(CreationDate)="data"><div class="text-ellipsis">{{ data.value | formatDateTime }}</div></template>
        <template #cell(Reference)="data"><div class="text-ellipsis" >{{ data.value }}</div></template>
        <template #cell(Name)="data"><div class="text-ellipsis">{{ data.item.CompanyName != '' ? data.item.CompanyName : data.item.FirstName +' '+ data.item.LastName}}</div></template>
        <template #cell(MatchingResult)="data"><div class="text-ellipsis">{{ data.item.IdScore != '' ? data.item.IdScore : data.item.NameScore }}</div></template>
        <template #cell(Type)="data"><div class="text-ellipsis">{{ data.item.Type }}</div></template>
        <!--                <template #cell(flow)="data">-->
        <!--                  <div class="d-xl-flex align-items-center justify-content-center">-->
        <!--                    <span>{{ data.value }}</span>-->
        <!--                    <div>-->
        <!--                      <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml({id: data.item.idFormatIn, type: data.value}, (data.item.msgType === '5' ? 'payment' : 'requestToPay'), 'see')"></i>-->
        <!--                      <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml({id: data.item.idFormatIn, type: data.value}, (data.item.msgType === '5' ? 'payment' : 'requestToPay'), 'download')"></i>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </template>-->
      </b-table>
      <div v-else class="d-flex justify-content-center">
        <span class="noResult">
          {{ $t('common.no_result') }}
        </span>
      </div>
    </div>
    <b-row class="mt-5">
      <b-col>
        <b-col cols="12">
          <cm-pagination
            :maxResultsByPage="paginationObject.maxResults"
            :firstIndex="paginationObject.firstIndex"
            :nbResultsTotal="paginationObject.nbResultsTotal"
            :refreshEvent="paginationObject.refresh">
          </cm-pagination>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import moment from "moment";

import MessagesFilter from "@/components/common/Filter";
import Spinner from "@/components/common/spinner.vue";
import Pagination from "@/components/common/pagination.vue";

import { errorMessageAlert } from "@/helpers/alert";
import services from "@/helpers/services";
import { downloadFileWithDefinedHeaders } from '@/helpers/download';
import dateTimePicker from "@/components/common/dateTimePicker.vue";
import {loadPage} from "@/helpers/routing";

export default {
  name: "OprhanFlux",
  components: {
    "cm-messages-filter": MessagesFilter,
    "spinner": Spinner,
    'datetime-picker-custom': dateTimePicker,
    "cm-pagination": Pagination,
  },
  props: {
    direction: {
      default: "2",
      type: String,
    },
    modeFilter: {
      default: "4",
      type: String,
    },
    filterType: {
      type: String,
      default: 'list'
    },
  },
  created() {
    this.$bus.$emit("change-mobile-header", {
      backLink: false,
      navbarInnerStyle: "justify-content:start;",
      navTitle: this.$t('Webheader.orphan'),
      returnUrl: "",
    });
    this.paginationObject["firstIndex"] = 1;
    this.paginationObject["maxResults"] = 15
    this.paginationObject["nbResultsTotal"] = 0;
    // this.$engine.services.payments.filter.cleanFilterCondition()
    this.mode = parseInt(this.modeFilter, 10);
    let that = this;
    this.$engine.settings.set({ msgDirection: this.direction });

    this.clearingListCreated = false

    this.$bus.$on('language-changed', () => {
      that.fields = [
        { key: "CreationDate", label: this.$t('common.date_label'), class: 'text-center' },
        { key: "Reference", label: this.$t('orphan.reference'), class: "text-center" },
        { key: "Name", label: this.$t('orphan.name'), class: "text-center" },
        { key: "MatchingResult", label: this.$t('orphan.matching_result_label'), class: "text-center font-weight-bold" },
        { key: "Type", label: this.$t('orphan.type'), class: "text-center font-weight-bold" }
      ]
      that.onRefresh(false)
      that.pageCounter = 0
    })

    this.$bus.$off("refresh-cache-contacts");
    this.paginationObject['refresh'] = 'inbox-filtered'
    this.$bus.$off('inbox-filtered')
    this.$bus.$off('refresh-inbox-on-seen')
    this.$bus.$on('inbox-filtered', index => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false);
  },
  mounted() {
    this.$$(".infinite-scroll-preloader").remove();
    this.$bus.on("service:change", (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val);
    });
  },
  beforeDestroy() {
  },
  data () {
    return {
      activateSpinner: false,
      clearingList: [],
      resultTypeList: {
        NOAP: {
          label: this.$t('orphan.matching_result.1'),
          id: '1',
          icon: '',
          state: 0
        },
        MTCH: {
          label: this.$t('orphan.matching_result.2'),
          id: '2',
          icon: '',
          state: 0
        },
        NMTC: {
          label: this.$t('orphan.matching_result.3'),
          id: '3',
          icon: '',
          state: 0
        },
        CMTC: {
          label: this.$t('orphan.matching_result.4'),
          id: '4',
          icon: '',
          state: 0
        },
      },
      clearingListCreated: false,
      filterConditions: {},
      items: [],
      keyTableFlux: false,
      displayFilter: false,
      mode: 8,
      Name: '',
      Reference: '',
      type: '',
      MatchingResult: '',
      dateBegin: '',
      dateEnd: '',
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      scrollFlag: true,
      services: services,
      serviceId: this.$engine.user.currentService.id.toString(),
      serviceName: this.$t("common.appname"),
      randomString: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
    };
  },
  computed: {
    realMessageTypeList () {
      let that = this
      const list = []
      for (const property in that.resultTypeList) {
        const type = that.resultTypeList[property]
        list.push({
          tag: property,
          label: type.label,
          icon: type.icon,
          state: type.state,
          id: type.id
        })
      }
      return list
    },
    messageTypeDisplay () {
      let realMessageTypeList = this.realMessageTypeList.filter(type => type.state === 1)
      if (realMessageTypeList.length === 0) {
        return {
          label: this.$t('filter.selected_msg_type_none'),
          nb: 0
        }
      } else if (realMessageTypeList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('orphan.matching_result.' + realMessageTypeList[0].id) : realMessageTypeList[0].label,
          icon: realMessageTypeList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_msg_type_many', {nbMsgType: realMessageTypeList.length}),
          nb: realMessageTypeList.length
        }
      }
    },
    hasInputFilter () {
      if (
          this.Reference ||
          this.Name ||
          this.MatchingResult ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    },
    fields () {
      return [
        { key: "CreationDate", label: this.$t('common.date_label'), class: 'text-center' },
        { key: "Reference", label: this.$t('orphan.reference'), class: "text-center" },
        { key: "Name", label: this.$t('orphan.name'), class: "text-center" },
        { key: "MatchingResult", label: this.$t('orphan.matching_result_label'), class: "text-center font-weight-bold" },
        { key: "Type", label: this.$t('orphan.type'), class: "text-center font-weight-bold" }
      ]
    },
    customMobileLayoutStyle() {
      if (this.serviceId === services.PAYMENTS) {
        return 'h-136px;'
      } else {
        return 'h-90px;'
      }
    },
  },
  methods: {
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/orphan/' + id})
    },
    seeOrphansDetails (items) {
      this.activateDetail(items[0].IdOrphan)
    },
    applyFilter (filterConditions = {}) {
      let that = this

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      filterConditions.Reference = this.Reference
      filterConditions.Name = this.Name
      let filterMatchingResult = ''
      let first = true
      for (let resultTypeListKey in this.resultTypeList) {
        if (this.resultTypeList[resultTypeListKey].state){
          if (first) {
            filterMatchingResult += "\"" +resultTypeListKey+ "\""
            first = false
          } else {
            filterMatchingResult += ",\"" + resultTypeListKey+ "\""
          }
        }
      }
      filterConditions.MatchingResult = filterMatchingResult
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex
      this.$engine.orphan.getOrphans(
        filterConditions
      ).then(resp => {
        let orphans = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalOprhans
        that.paginationObject.nbResults = resp.data.orphans.length
        orphans = resp.data.orphans
        that.updateItems(orphans)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    clearFilterFields () {
      this.Reference = ''
      this.Name = ''
      this.MatchingResult = ''
      this.dateEnd = ''
      this.dateBegin = ''
      // this.applyFilter()
    },
    extractCSV (inboxMessages) {
      let that = this


      let filterConditions = {
        extract: 1,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
      }

      this.$engine.orphan.getOrphans(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + resp.data
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName ='Orphan_' + today.unix() + '.csv'
        if (
            this.$f7.device.os === 'android' ||
            this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getClearingTitleColor (clearing, index) {
      return 'clearing-color-' + clearing.toLowerCase()
    },
    getMessageTypeLabel (id) {
      return this.$t('filter.orphan.message_type.' + id)
    },
    isDataJSON (data) {
      let raw = data.substr(23)
      raw = atob(raw)
      try {
        return JSON.parse(raw)
      } catch (e) {
        return false
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0
      this.activateSpinner = true
      let filterConditions = {}
      filterConditions.Reference = this.Reference
      filterConditions.Name = this.Name
      let filterMatchingResult = ''
      let first = true
      for (let resultTypeListKey in this.resultTypeList) {
        if (this.resultTypeList[resultTypeListKey].state){
          if (first) {
            filterMatchingResult += "\"" +resultTypeListKey+ "\""
            first = false
          } else {
            filterMatchingResult += ",\"" + resultTypeListKey+ "\""
          }
        }
      }
      filterConditions.MatchingResult = filterMatchingResult
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      this.$engine.orphan.getOrphans(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let orphans = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalOprhans
        that.paginationObject.nbResults = resp.data.orphans.length
        orphans = resp.data.orphans
        that.updateItems(orphans)
        that.updateInbox(orphans, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    refreshInbox () {
      this.onRefresh()
    },
    seeXml (data, service, action) {
      let that = this
      const id = data.id
      const type = data.type ? data.type : 'Technical_Error'
      let xmlDetails = {}
      this.$engine.services.payments
        .getXml(service, type, id)
        .then((resp) => {
          if (resp.data) {
            xmlDetails = resp.data
            xmlDetails.type = type
            if (action === 'see') {
              that.$bus.emit('popup-xml-details', xmlDetails)
            } else {
              //download file
              let extension = '.xml'
              let message = that.$i18n.t('common.xml_downloaded')
              if (that.isDataJSON(resp.data.data)) {
                extension = '.json'
                message = that.$i18n.t('common.json_downloaded')
              }
              const fileName = moment().format('YYYYMMDD_hhmmss_') + type + extension
              downloadFileWithDefinedHeaders(that, fileName, resp.data.data)
              that.$f7.alert('', message)
            }
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    updateInbox (orphans, noAttach = false) {
      this.inboxMessages = orphans
      if (orphans.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          // this.attachInfinit()
        }
      } else {
        // this.detachInfinit()
      }
    },
    updateItems (orphans) {
      this.items = []
      this.items = orphans
      // for (var i = 0; i < orphans.length; i++) {
      //
      //   if (!this.clearingList.includes(orphans[i].standard)) {
      //     this.clearingList.push(orphans[i].standard)
      //   }
      //
      //   let date = orphans[i].datetime
      //
      //   let result = {
      //     id: orphans[i].id,
      //     idFormatIn: orphans[i].id_format_in,
      //     direction: orphans[i].direction,
      //     dateTime: date,
      //     clearing: orphans[i].standard,
      //     msgType: orphans[i].messageType,
      //     initParty: orphans[i].initParty,
      //     msgId: orphans[i].msgId,
      //     flow: orphans[i].type
      //   }
      //   this.items.push(result)
      // }
    }
  },
};
</script>
